module.exports = __webpack_public_path__ + "static/media/metal-alloys-01.83c5ad87.jpg";